/*
 * @Author: along longwang6@163.com
 * @Date: 2026-06-15 10:01:21
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2026-06-22 16:52:46
 * @FilePath: /ehr-web/src/components/NavBar/components/Todo/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { useStore } from '@/store';
import styles from './index.module.less';
import TodoIcon from '@/assets/todoIcon.svg';
import TodoIconActive from '@/assets/todoIconActive.svg';
import { Tooltip } from '@arco-design/web-react';

interface IProps {
  active?: boolean;
  onOpen?: () => void;
}

const Todo = ({ active = false, onOpen }: IProps) => {
  const { todoCount } = useStore('user');
  return (
    <div
      className={`${styles.todoEntry} ${active ? styles.todoEntryActive : ''}`}
      onClick={onOpen}
    >
      <Tooltip
        content={active ? '关闭待办' : '打开待办'}
        position="bottom"
        style={{ zIndex: 1101 }}
      >
        {active ? (
          <TodoIconActive className={styles.todoIcon} />
        ) : (
          <TodoIcon className={styles.todoIcon} />
        )}
      </Tooltip>
      {/* <span>我的待办</span> */}
      {todoCount > 0 && <em>{todoCount}</em>}
    </div>
  );
};
export default Todo;
